module.exports = __webpack_public_path__ + "img/wallpaper2.572d9419.png";